export default __webpack_public_path__ + "static/media/react_native.55360266.svg";